import React from "react";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import { LogoutOutlined } from "@ant-design/icons";
import { SuccessMessage } from "../../Utils/Utils";
import { useHistory } from "react-router-dom";
// import "./Logout.css";
import "../../GlobalCss/SPF/Logout.css";
import { BaseUrl, JsonConfig } from "../../Repository/BaseRepository";
import axios from "axios";
const Logout = () => {

  const [activePage, setActivePage] = useState(
    localStorage.getItem("ActivePage") || "1"
  );
  const navigate = useHistory();
  const jwtToken = Cookies.get("jwt_token");
  const userLogin = Cookies.get("UserLogin");
  const firstName = Cookies.get("first_name");
  const lastName = Cookies.get("last_name");
  const tenantName = Cookies.get("tenant_name")

  const onClickLogout = async (e) => {
    e.preventDefault();
    try {
      let url = `${BaseUrl}Auth/logout`;
      const body = JSON.stringify(userLogin);

      const response = await axios.post(url, body, JsonConfig);

      if (response.status === 200) {
        const { message } = response.data;
        SuccessMessage(message);

        Cookies.remove("jwt_token");
        Cookies.remove("UserLogin");
        Cookies.remove("first_name");
        Cookies.remove("last_name");
        Cookies.remove("Role");
        Cookies.remove("Date");
        Cookies.remove("tenant_name")
        localStorage.removeItem("ActivePage");
        setActivePage("1");

        navigate.push({
          pathname: `/${tenantName}`,
          state: { logoutMsg: "yes" },
        });

      } else {
        console.error("Failed to logout from API:", response.statusText);
      }
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };
  return (
    <div>
      <button
        onClick={onClickLogout}
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
        }}
      >
        <img
          src="/Images/Icons/Logout1.svg"
          alt="Logout"
          style={{ height: 23, width: 23, fontSize: 10, marginRight: 8, marginTop: 12 }}
        />
      </button>
    </div>
  );
};
export default Logout;
